import React from "react";
import PropTypes from 'prop-types';
import { Card, Col, Row } from "react-bootstrap";

const CardDates = ({ setDesde, desde, setHasta, hasta }) => {
    return (
        <Card>
            <Card.Body>
                <Row>
                    <Col>
                        <label className="form-label">Desde</label>
                        <input
                            type="date"
                            className="form-control"
                            value={desde || ""}
                            onChange={(e) => setDesde(e.target.value)}
                        />
                    </Col>
                    <Col>
                        <label className="form-label">Hasta</label>
                        <input
                            type="date"
                            className="form-control"
                            value={hasta || ""}
                            onChange={(e) => setHasta(e.target.value)}
                        />
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

CardDates.propTypes = {
    setDesde: PropTypes.func.isRequired,
    desde: PropTypes.string,
    setHasta: PropTypes.func.isRequired,
    hasta: PropTypes.string,
};

export default CardDates;
